import { clsx } from 'clsx'
import useSWR from 'swr'

import styles from './PlatformStatus.module.scss'
import { SidebarAddon, SidebarAddonTitleLink } from '../../SidebarAddon.tsx'

async function statusFetch(url: string) {
  const res = await fetch(url, {
    mode: 'cors',
    credentials: 'omit',
  })
  const data = await res.json()
  return data
}

function StatusUnknown() {
  return (
    <div className={clsx(styles.platformStatus, styles.platformStatusUnknown)}>
      Status could not be determined. Check{' '}
      <strong>
        <a href="https://twitter.com/TLStatus" target="_blank" rel="noreferrer">
          @TLStatus on Twitter
        </a>
      </strong>{' '}
      for updates.
    </div>
  )
}

function StatusOk() {
  return (
    <div className={clsx(styles.platformStatus, styles.platformStatusOk)}>
      All services operational
    </div>
  )
}

function StatusIncident() {
  return (
    <div className={clsx(styles.platformStatus, styles.platformStatusIncident)}>
      <strong>
        <a href="https://transloaditstatus.com/" target="_blank" rel="noreferrer">
          Incident
        </a>
        .
      </strong>{' '}
      We are currently investigating issues with the platform
    </div>
  )
}

function PlatformStatus() {
  const { data, error } = useSWR('https://transloaditstatus.com/api.json', statusFetch)

  let content = null
  if (data) {
    if (data.status === 'Ok') {
      content = <StatusOk />
    } else {
      content = <StatusIncident />
    }
  } else if (error) {
    content = <StatusUnknown />
  } else {
    // Loading: show nothing yet
    return null
  }

  return (
    <SidebarAddon
      titleMuted
      title={
        <SidebarAddonTitleLink
          className="link-external"
          href="https://transloaditstatus.com/"
          title="Open Transloadit’s status page"
          target="_blank"
          rel="noreferrer"
        >
          Platform status
        </SidebarAddonTitleLink>
      }
    >
      {content}
    </SidebarAddon>
  )
}

export default PlatformStatus
